/* NCL creator collection page behavior: countdowns, copy code, sticky bar, add to cart. */
(function () {
  if (window.__nclCC) return;
  window.__nclCC = true;
  var D = document;
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = Date.now();
    D.querySelectorAll('[data-cc-countdown]').forEach(function (el) {
      var s = Date.parse(el.getAttribute('data-start') || '');
      var e = Date.parse(el.getAttribute('data-end') || '');
      if (isNaN(e) || (!isNaN(s) && now < s) || now >= e) { el.hidden = true; return; }
      var t = Math.floor((e - now) / 1000);
      el.querySelector('[data-cc-text]').textContent =
        Math.floor(t / 86400) + 'd ' + pad(Math.floor(t % 86400 / 3600)) + 'h ' + pad(Math.floor(t % 3600 / 60)) + 'm ' + pad(t % 60) + 's';
      el.hidden = false;
    });
  }
  setInterval(tick, 1000);
  tick();

  var io;
  function initSticky() {
    if (io) { io.disconnect(); io = null; }
    var bar = D.querySelector('[data-cc-sticky]');
    var hero = D.querySelector('[data-cc-hero]');
    if (!bar || !hero || !('IntersectionObserver' in window)) { if (bar) bar.classList.add('is-on'); return; }
    io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(hero);
  }
  initSticky();
  D.addEventListener('shopify:section:load', initSticky);

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) return navigator.clipboard.writeText(text);
    return new Promise(function (res) {
      var ta = D.createElement('textarea'); ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      D.body.appendChild(ta); ta.select(); try { D.execCommand('copy'); } catch (e) {} D.body.removeChild(ta); res();
    });
  }

  function postJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function cartSectionIds() {
    var ids = [];
    var drawer = D.querySelector('cart-drawer-component');
    if (drawer) { var s = drawer.closest('[id^="shopify-section-"]'); if (s) ids.push(s.id.replace('shopify-section-', '')); }
    D.querySelectorAll('cart-icon-component, [class*="cart-icon"], cart-bubble').forEach(function (el) {
      var s = el.closest && el.closest('[id^="shopify-section-"]');
      if (s) { var id = s.id.replace('shopify-section-', ''); if (ids.indexOf(id) === -1) ids.push(id); }
    });
    return ids;
  }
  function refreshDrawer() {
    var param = cartSectionIds().join(',');
    var sections = param ? fetch('/?sections=' + param).then(function (r) { return r.json(); }) : Promise.resolve({});
    return Promise.all([sections, fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
      D.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: res[1], sourceId: 'ncl-cc-add', data: { source: 'ncl-cc-add', itemCount: res[1].item_count, sections: res[0] } } }));
    });
  }
  function openDrawer() {
    var drawer = D.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.showDialog === 'function') drawer.showDialog();
    else if (typeof drawer.open === 'function') drawer.open();
  }

  D.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t) return;

    var copy = t.closest('[data-cc-copy]');
    if (copy) {
      ev.preventDefault();
      var label = copy.getAttribute('data-label') || 'COPY';
      copyText(copy.getAttribute('data-code') || '').then(function () {
        copy.classList.add('is-copied');
        copy.querySelector('[data-cc-copy-label]').textContent = 'Copied';
        setTimeout(function () { copy.classList.remove('is-copied'); copy.querySelector('[data-cc-copy-label]').textContent = label; }, 2000);
      });
      return;
    }

    var btn = t.closest('[data-cc-add]');
    if (!btn) return;
    ev.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var code = btn.getAttribute('data-code');
    var old = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    postJson('/cart/add.js', { id: id, quantity: 1 })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return code ? fetch('/discount/' + encodeURIComponent(code)).catch(function () {}) : null; })
      .then(function () { return refreshDrawer(); })
      .then(function () { openDrawer(); btn.textContent = 'Added to cart'; })
      .catch(function (err) { console.warn('[ncl-cc] add to cart', err); btn.textContent = old; })
      .then(function () { setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 1800); });
  });
})();
